 import { IMSObject, IMSId } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

export class BillOfQuantity extends IMSObject {
  static fromDto(dto: BillOfQuantityDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/BillOfQuantities'
      },
      dto.label,
      dto.servicejob && dto.servicejob.id
        ? new IMSObject(
            dto.servicejob.id,
            undefined,
            dto.servicejob.label,
            'ims/ServiceJob'
          )
        : undefined,
    );
    
    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }
    
    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public servicejob: IMSObject,
  ) {
    super(id.imsId, id.secondaryId, label, id.objRef);
  }
}

export interface BillOfQuantityDTO {
  id: number;
  secondaryid: number;
  label: string;
  servicejob: {
    id: number;
    label: string;
  };
}
